export default __webpack_public_path__ + "static/media/sbj-computerscience.b31c6a71.svg";